import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Present = {
  present_id?: number; // 선물 idx
  user_id?: number; // 유저 idx
  order_reservation_id?: number; //
  image?: string; // 이미지
  barcode?: string; // 바코드
  message?: string; // 메세지
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
  use_date?: number; // 사용일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Present
   * --
   */
  getPresents: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_PRESENT, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Present
   * --
   */
  getPresent: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_PRESENT, { present_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Present
   * --
   */
  createPresent: async (body: Present) => {
    try {
      const res = await $http.post(APIConstant.CREATE_PRESENT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Present
   * --
   */
  updatePresent: async (body: Present) => {
    try {
      const { present_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_PRESENT, {
        present_id: present_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Present
   */
  updateAmountPresent: async (body: Present) => {
    try {
      const { present_id } = body;
      const url = parameterToPath(APIConstant.AMOUNT_PRESENT, {
        present_id: present_id,
      });
      const res = await $http.put(url, body);
      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Present
   * --
   */
  deletePresent: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_PRESENT, {
        present_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Present
   * --
   */
  sendPresent: async (body: Present) => {
    try {
      const res = await $http.multipart(APIConstant.SEND_PRESENT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GETS] Present Guest
   * --
   */
  getPresentGuest: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_PRESENT_GUEST, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Cancel Present
   * --
   */
  cancelPresent: async (body: Present) => {
    try {
      const { present_id } = body;
      const url = parameterToPath(APIConstant.CANCEL_PRESENT, {
        present_id: present_id,
      });

      const res = await $http.post(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
